module.exports = __webpack_public_path__ + "img/mention.75cede8b.svg";